import { OrbitControls } from "./OrbitControls";

export class ZoomController
{
	private _zoomIn: HTMLElement;
	private _zoomOut: HTMLElement;
	private _orbitControls: OrbitControls;

	constructor(orbitControls: OrbitControls)
	{
		this._orbitControls = orbitControls;

		this._zoomIn = <HTMLElement>document.getElementById("zoom_in");
		this._zoomOut = <HTMLElement>document.getElementById("zoom_out");

		this._zoomIn.addEventListener("click", this.onZoomIn);
		this._zoomOut.addEventListener("click", this.onZoomOut);
	}

	private onZoomIn = (event:MouseEvent) =>
	{
		this._orbitControls.zoomIn();
	};

	private onZoomOut = (event:MouseEvent) =>
	{
		this._orbitControls.zoomOut();
	};
}